import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CreatableSelect from "react-select/creatable";

import {
  ActionIconContainer,
  AddFormButton,
} from "../../../shared/components/TableElements";
import { openDropdownStyles } from "../../../shared/constants/styles";
import CustomMenuList from "../../../shared/components/form/CustomMenuList";
import { colorLightGray } from "../../../utils/palette";
import IssuesFormPopup from "../../Issues/IssuesFormPopup";
import MultiValueOption from "../../../shared/components/form/MultiValueOption";

const AddIssueModal = ({
  showAddIssueModal,
  setShowAddIssueModal,
  issues,
  setIssues,
  issuesList,
  vehicle,
  onNewIssueAdded,
}) => {
  const { t } = useTranslation("common");

  const [selectedTasks, setSelectedTasks] = useState([]);
  const [showIssuesFormPopup, setShowIssuesFormPopup] = useState(false);

  const newIssueName = useRef(null);

  // When modal opens, sync selected tasks from parent's issues
  useEffect(() => {
    if (showAddIssueModal) {
      setSelectedTasks(issues);
    }
  }, [showAddIssueModal]);

  // useEffect(() => {
  //   setSelectedTasks(issues);
  // }, [issues]);

  const handleOK = () => {
    setIssues(selectedTasks);
    setShowAddIssueModal(false);
  };

  const handleCreateNewIssue = (value) => {
    newIssueName.current = value;
    setShowIssuesFormPopup(true);
  };

  const handleNewIssueAdded = async (issueId) => {
    const newIssue = onNewIssueAdded
      ? await onNewIssueAdded(issueId)
      : null;
    setShowIssuesFormPopup(false);
    if (newIssue) {
      setSelectedTasks((prev) => {
        const exists = prev.some(
          (issue) => issue.issue_id === newIssue.issue_id,
        );
        if (exists) return prev;
        return [...prev, newIssue];
      });
    }
  };

  return (
    <>
      {showIssuesFormPopup && vehicle && (
        <IssuesFormPopup
          showPopup={showIssuesFormPopup}
          setShowPopup={setShowIssuesFormPopup}
          vehicle={vehicle}
          onNewIssueAdded={handleNewIssueAdded}
          newIssueName={newIssueName.current}
        />
      )}
      <Modal
        show={showAddIssueModal && !showIssuesFormPopup}
        onHide={() => setShowAddIssueModal((prev) => !prev)}
      >
        <Modal.Body>
          <div className="d-flex justify-content-end mb-2">
            <ActionIconContainer
              onClick={() => setShowAddIssueModal((prev) => !prev)}
            >
              <i className="fi fi-rr-cross-small" />
            </ActionIconContainer>
          </div>
          <div
            style={{
              height: `${window.innerHeight - 170}px`,
            }}
          >
            <CreatableSelect
              options={issuesList}
              value={selectedTasks}
              onChange={setSelectedTasks}
              placeholder={t("issue_name")}
              styles={{
                ...openDropdownStyles,
                menu: (provided) => ({
                  ...provided,
                  margin: 0,
                  height: `${window.innerHeight - 240}px`,
                  border: `1px solid ${colorLightGray}`,
                  boxShadow: "none",
                }),
              }}
              defaultMenuIsOpen
              isMulti
              menuIsOpen
              isClearable
              isSearchable
              closeMenuOnSelect={false}
              controlShouldRenderValue={true}
              hideSelectedOptions={false}
              components={{
                Option: MultiValueOption,
                MenuList: CustomMenuList,
              }}
              onCreateNew={() => handleCreateNewIssue("")}
              onCreateOption={handleCreateNewIssue}
              createNewLabel={t("create_new_issue")}
              customProps={{
                type: "issue",
              }}
              // Disable creatable "Create '...'" prompt from typing
              //isValidNewOption={() => false}
            />
          </div>
          <div className="d-flex justify-content-end align-items-center">
            <AddFormButton onClick={handleOK}>{t("ok")}</AddFormButton>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddIssueModal;
